import { FormControlLabel, RadioButton, RadioGroup, Typography } from "@tm/components"
import { useLocalization } from "@tm/localization"
import { useMemo } from "react"
import { VoucherType } from "@tm/models"
import { useUser } from "@tm/context-distribution"

type Props = {
    selectedVoucherType: VoucherType
    onVoucherTypeChanged(event: React.ChangeEvent<HTMLInputElement>): void
}

export type VoucherTypeRadioItem = {
    voucherType: VoucherType
    value: React.ReactNode
}

export function ViewFilter(props: Props) {
    const { selectedVoucherType, onVoucherTypeChanged } = props
    const { translateText } = useLocalization()
    const { showVoucherKVA, showVoucherOrder, showVoucherReturn } = useUser().userContext.parameter

    const items = useMemo(() => {
        function renderRadioButtonLabel(textId: number): React.ReactNode {
            return <Typography variant="label">{translateText(textId)}</Typography>
        }

        const result: Array<VoucherTypeRadioItem> = []

        if (showVoucherKVA) {
            result.push({ voucherType: VoucherType.CostEstimation, value: renderRadioButtonLabel(82) })
        }

        if (showVoucherOrder) {
            result.push({ voucherType: VoucherType.Order, value: renderRadioButtonLabel(292) })
        }

        if (showVoucherReturn) {
            result.push({ voucherType: VoucherType.Return, value: renderRadioButtonLabel(13256) })
        }

        return result
    }, [showVoucherKVA, showVoucherOrder, showVoucherReturn, translateText])

    const selectedItem = items.find((x) => x.voucherType === selectedVoucherType)?.voucherType || items[0]?.voucherType

    return (
        <>
            <Typography variant="body3" sx={{ textTransform: "uppercase" }}>
                {translateText(222)}
            </Typography>
            <RadioGroup value={selectedItem} onChange={onVoucherTypeChanged}>
                {items.map((item) => {
                    return (
                        <FormControlLabel key={item.voucherType} value={item.voucherType} control={<RadioButton size="small" />} label={item.value} />
                    )
                })}
            </RadioGroup>
        </>
    )
}
